import { render, staticRenderFns } from "./PopoverCompany.vue?vue&type=template&id=3910fa2a"
import script from "./PopoverCompany.vue?vue&type=script&lang=js"
export * from "./PopoverCompany.vue?vue&type=script&lang=js"
import style0 from "./PopoverCompany.vue?vue&type=style&index=0&id=3910fa2a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports